/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/product/testimonials.js":
/*!*******************************************************!*\
  !*** ./zrc/scripts/templates/product/testimonials.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* eslint-disable no-undef */\n\nclass ProductTestimonials extends HTMLElement {\n  connectedCallback() {\n    this.slider = this.querySelector('.pt-modal-swiper');\n    this.$videos = this.querySelectorAll('video[data-src]');\n    this.initModal();\n    this.initSlider();\n\n    // execute _loadVideos methos on window load\n    window.addEventListener('load', this._loadVideos.bind(this));\n    // Execute _loadVideos method on testimonials::reloaded custom event\n    document.addEventListener('testimonials::reloaded', this._loadVideos.bind(this));\n  }\n  initModal() {\n    var $openModalButtons = this.querySelectorAll('.pt-item');\n    var $closeModalButtons = this.querySelectorAll('.js-close-modal');\n    var $swiperContainer = this.querySelector('.pt-modal-swiper');\n    $openModalButtons.forEach($button => {\n      $button.addEventListener('click', () => {\n        var $parent = $button.parentNode;\n        var $buttonIndex = Array.prototype.indexOf.call($parent.children, $button);\n        this.openModal($buttonIndex);\n      });\n    });\n    $swiperContainer.addEventListener('click', event => {\n      if (event.target.classList.contains('pt-modal-swiper') || event.target.classList.contains('swiper-wrapper')) {\n        this.closeModal();\n      }\n    });\n    $closeModalButtons.forEach($button => {\n      $button.addEventListener('click', this.closeModal.bind(this));\n    });\n  }\n  openModal(slideIndex) {\n    this.swiper.slideTo(slideIndex, 0);\n    var $modal = this.querySelector('.pt-modal');\n    $modal.classList.add('is-open');\n    document.body.classList.add('pt-modal-open');\n    this.onModalOpen();\n  }\n  closeModal() {\n    var $modal = this.querySelector('.pt-modal');\n    $modal.classList.remove('is-open');\n    document.body.classList.remove('pt-modal-open');\n    this.onModalClose();\n  }\n  onModalClose() {\n    this._pauseAllVideos();\n  }\n  onModalOpen() {\n    this._pauseAllVideos();\n    this._playActiveSlideVideo();\n  }\n  initSlider() {\n    // Función para inicilizar el slider principal del producto\n\n    // La configuración de slick.js\n    var swiperSettings = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation],\n      touchThreshold: 500,\n      slidesPerView: \"auto\",\n      centeredSlides: true,\n      watchSlidesProgress: true,\n      spaceBetween: 16,\n      infinite: false,\n      loop: false,\n      longSwipesRatio: 0,\n      resistanceRatio: 0,\n      navigation: {\n        nextEl: '.pt-modal-button.next',\n        prevEl: '.pt-modal-button.prev'\n      },\n      breakpoints: {\n        680: {\n          spaceBetween: 24\n        }\n      }\n    };\n\n    // Inicializacion del slider\n    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default(this.slider, swiperSettings);\n\n    // Manejo de videos al cambiar de slide\n    this.swiper.on('slideChange', this.onSlideChange.bind(this));\n  }\n  onSlideChange() {\n    this._pauseAllVideos();\n    this._playActiveSlideVideo();\n  }\n  _pauseAllVideos() {\n    var $videos = this.querySelectorAll('video');\n    $videos.forEach($video => {\n      $video.pause();\n    });\n  }\n  _playActiveSlideVideo() {\n    var activeIndex = this.swiper.activeIndex;\n    var $currentSlide = this.swiper.slides[activeIndex];\n    var $video = $currentSlide.querySelector('video');\n    if ($video !== null) {\n      $video.play();\n    }\n  }\n  _loadVideos() {\n    this.$videos.forEach($video => {\n      // attach data-src attribte value to src attribute\n      $video.setAttribute('src', $video.getAttribute('data-src'));\n      $video.setAttribute('type', 'video/mp4');\n      // Remove data-src attribute from video\n      $video.removeAttribute('data-src');\n    });\n  }\n}\nwindow.customElements.define('product-testimonials', ProductTestimonials);\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/product/testimonials.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product-testimonials": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/product/testimonials.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;